export const DRINK_DISCOVERY_EVENT = 'pfandpirat:drink-discovery';

export function emitDrinkDiscovery(discovery) {
  if (!discovery || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(DRINK_DISCOVERY_EVENT, { detail: discovery }));
}

export function emitDrinkDiscoveryChanges(discovery) {
  if (!discovery) return;
  if (discovery.previous_discovery) emitDrinkDiscovery(discovery.previous_discovery);
  emitDrinkDiscovery(discovery);
}
